export default __webpack_public_path__ + "static/media/51.c2e357ed.png";